import clsx from "clsx";
import { HTMLAttributes, ReactElement, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

const Step = ({
  icon: Icon,
  active,
  onClick,
}: {
  step: ReactNode;
  icon?: (props: HTMLAttributes<HTMLImageElement>) => ReactElement;
  active: boolean;
  onClick: () => void;
}) => {
  return (
    <div
      onClick={onClick}
      className={twMerge(
        clsx(
          "relative z-2 bg-primary cursor-pointer aspect-square",
          " text-center flex justify-center",
          "w-24 md:w-32 h-24 md:h-32",
          "content-center items-center border-8 border-green text-green rounded-full"
        )
      )}
    >
      {active && Icon && (
        <Icon className={"w-full h-full object-contain rounded-full"} />
      )}
    </div>
  );
};

const Stepper = ({
  steps,
  activeStep,
  classNames,
  setActiveStep,
}: {
  steps: {
    step: ReactNode;
    icon?: (orops: HTMLAttributes<HTMLImageElement>) => ReactElement;
  }[];
  classNames?: string;
  activeStep: number;
  setActiveStep: (step: number) => void;
}) => {
  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };

  // const progress = useMemo(
  //   () => ((activeStep + 1) / steps.length) * 100,
  //   [steps, activeStep]
  // );

  return (
    <div
      className={twMerge(
        clsx(
          "relative flex flex-row justify-center gap-5 py-6 align-center",
          classNames
        )
      )}
    >
      <hr
        className={twMerge(
          clsx(
            "top-1/2 z-0 absolute border-8 w-64 md:w-96 text-green -translate-y-1/2"
          )
        )}
      />

      {steps.map(({ step, icon }, index) => {
        return (
          <Step
            key={index}
            step={step}
            icon={icon}
            active={activeStep >= index}
            onClick={() => handleStepChange(index)}
          />
        );
      })}
    </div>
  );
};

export default Stepper;
